import { Outlet } from "react-router-dom";
import { useEffect } from "react";
import { AdminProvider } from "@/admin/store";

const AdminRoot = () => {
  useEffect(() => {
    document.body.classList.add("admin-mode");
    return () => document.body.classList.remove("admin-mode");
  }, []);
  return (
    <AdminProvider>
      <Outlet />
    </AdminProvider>
  );
};

export default AdminRoot;
